import { useLocation, Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import {
  routesConfig,
  getPreviousRoute,
  getNextRoute,
} from "../../routes-config";
import "./footer.scss";

const getBasePath = (path: string): string => {
  const segments = path.split("/").filter(Boolean);
  return segments.length > 1 ? `/${segments[0]}` : path;
};

export function Footer() {
  const { translations } = useI18n();
  const location = useLocation();
  const year = new Date().getFullYear();

  const basePath = getBasePath(location.pathname);
  const previousRoute = getPreviousRoute(basePath);
  const nextRoute = getNextRoute(basePath);

  const getLabel = (key: string): string => {
    const navTranslations: Record<string, string> = {
      home: translations.nav.home,
      career: translations.nav.career,
      projects: translations.nav.projects,
      articles: translations.nav.articles,
      photos: translations.nav.photos,
      games: translations.nav.games,
      updates: translations.nav.updates,
      contact: translations.nav.contact,
      tools: translations.nav.tools,
    };

    return navTranslations[key] || key;
  };

  return (
    <footer className="footer">
      <div className="footer-nav">
        <div className="footer-nav__item">
          {previousRoute ? (
            <Link to={previousRoute.path} className="footer-nav__link">
              <span className="footer-nav__label">{getLabel("previous")}</span>
              <span className="footer-nav__title">
                {getLabel(previousRoute.label)}
              </span>
            </Link>
          ) : (
            <div className="footer-nav__placeholder" />
          )}
        </div>
        <div className="footer-nav__item footer-nav__item-right ">
          {nextRoute ? (
            <Link to={nextRoute.path} className="footer-nav__link">
              <span className="footer-nav__label">{getLabel("next")}</span>
              <span className="footer-nav__title">
                {getLabel(nextRoute.label)}
              </span>
            </Link>
          ) : (
            <div className="footer-nav__placeholder" />
          )}
        </div>
      </div>

      <div className="footer-sitemap">
        <div className="footer-sitemap__column">
          {routesConfig.map((route) => (
            <Link
              key={route.path}
              to={route.path}
              className="footer-sitemap__link"
            >
              {getLabel(route.label)}
            </Link>
          ))}
        </div>
      </div>

      <div className="footer-copyright">
        <p>{translations.footer.copyright.replace("{year}", String(year))}</p>
      </div>
    </footer>
  );
}
